import React, { useEffect, useState } from "react";
import PopupModal from "../../../Components/ModalComponent/PopupModal";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import DataTable from "../../../Components/DataTable/DataTable";
import { Popconfirm, Skeleton } from "@arco-design/web-react";
import { ManageApis } from "../../../AppServices/ManageApi";
import { Button } from "react-bootstrap";
import { convertUtcToBrowserTimeZone, dataTableInitialLoader, formatDate, formatingValue } from "../../../Functions/Utils";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";

import Loader from "../../../Components/LoaderComponent/Loader";
import MenuHeader from "../../../Components/MenuHeaderSection/MenuHeader";
import { useNavigate } from "react-router";
import moment from "moment";
import { async } from "q";
import { useStoreValues } from "../../../Context/storeProvider";

function Client() {

    const { user_Roll } = useStoreValues()
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
    };
    const [clientDataList, setClientDataList] = useState([]);
    const [data, setData] = useState([]);
    const [loader, setloader] = useState(false);
    const [tableLoader, setTableLoader] = useState(false);
    const [clientData, setClientData] = useState({});
    const [currentPage, setcurrentPage] = useState(1);
    const [pageSize, setpageSize] = useState(10);
    const [visible, setvisible] = useState({ show: false, type: "" });
    const [showAlert, setShowAlert] = useState(AlertinitialValue);
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('')

    const handleEditClientName = (param) => {
        setvisible((pre) => ({ show: true, type: "Edit_Client_Name" }));
        //console.log(param);

        setClientData((pre) => param);
    };

    const onclickView = (param) => {
        // ""
        //handle on click view btn in table

        navigate("/admin/clientdetails", { state: { userData: param } });
    };

    const handleSubmit = async () => {
        
        try {
            setloader(true);
            setvisible((pre) => ({ show: false, type: "" }));
            let response;
            const { createdDate, id, name } = clientData;
            switch (visible?.type) {
                case "Edit_Client_Name":
                    response = await ManageApis("post", global.updateClientDetails, {
                        id,
                        name,
                    });
                    if (response.message === "Success") {
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isSuccess: true,
                            isfalse: false,
                        }));
                        setloader(false);
                        setClientData((pre) => ({}));
                        getClientsListData();
                    } else {
                        setloader(false);

                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,

                            isfalse: true,
                        }));
                    }

                    break;
                case "New_Account":
                    response = await ManageApis("post", global.addClientDetails, {
                        name,
                    });
                    if (response.message === "Success") {
                        setvisible((pre) => ({ show: false, type: "" }));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isSuccess: true,
                        }));
                        setloader(false);
                        // ""
                        setClientData([]);
                        getClientsListData();
                    } else {
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isfalse: true,
                        }));
                        setloader(false);
                    }
                    break;

                default:
                    break;
            }
        } catch (error) {
            setloader(false);
            setvisible((pre) => ({ show: false, type: "" }));
            //console.log(error);
        }
    };
    const handleDeleteClient = async (param) => {
        try {
            setloader(true);
            const data = {
                id: param,
            };
            let result = await ManageApis("post", global.deleteClientDetails, data);
            if (result.message == "Success") {
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result?.response_data?.message,
                    isSuccess: true,
                }));
                getClientsListData();
                setloader(false);
            } else {
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result?.response_data?.message,
                    isfalse: true,
                }));
                setloader(false);
            }
        } catch (error) {
            setloader(false);
            //console.log(error);
        }
    };

    const TableColumn = [
        {
            title: "Name",
            dataIndex: "name",
            // sorter: (a, b) => {                            //not use currently if need sort uncomment it
            //   if (a.name > b.name) {
            //     return 1;
            //   }
            //   if (a.name < b.name) {
            //     return -1;
            //   }
            //   return 0;
            // },
            headerCellStyle: {
                backgroundColor: 'var(--mastercolor2)',
                color: '#fff'
            },
            render: (v, record) => {
                return (<div className="">{record.name}
                </div>)
            }
        },
        {
            title: "Modified Date",
            dataIndex: "modifiedDate",
            headerCellStyle: {
                backgroundColor: 'var(--mastercolor2)',
                color: '#fff'
            },
            render: (v, record) => {
                // ""
                return (<div>{convertUtcToBrowserTimeZone(record.modifiedDate)}</div>)


            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (v, record) => {
                //console.log({ record });
                return loader ? (
                    <Skeleton text={{ rows: 1, width: 100 }} />
                ) : (
                    //   <div className="col-12 ">
                    //     <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                    //       <button
                    //       className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                    //         onClick={() => handleEditClientName(record)}
                    //       >
                    //         Edit
                    //       </button>

                    //       <Popconfirm
                    //         title="Are you Sure ?"
                    //         okText={"OK"}
                    //         cancelText={"Cancel"}
                    //         onOk={() => handleDeleteClient(record.id)}
                    //       >
                    //         <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">
                    //           Delete
                    //         </button>
                    //         {/* <DeleteTwoTone /> */}
                    //       </Popconfirm>
                    //     </div>
                    //   </div>
                    <div className="col-12 ">
                        <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                            <button
                                className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100"
                                onClick={() => onclickView(record)}
                            >
                                View
                            </button>
                        </div>
                    </div>
                );
            },
            headerCellStyle: {
                backgroundColor: 'var(--mastercolor2)',
                color: '#fff'
            },
            width: "300px",
        },
    ];

    useEffect(() => {
        getClientsListData();
        localStorage.removeItem("key")
        localStorage.removeItem("keystatus")
    }, []);

    const getClientsListData = async () => {
        // ""
        try {
            setClientDataList([])
            // ""
            setloader(true);
            // setClientDataList(dataTableInitialLoader(TableColumn));
            let response = await ManageApis("get", global.getClientsList);
            //console.log(response);

            if (response.message === "Success") {
                setloader(false);
                setData(response?.response_data);
                setClientDataList(response?.response_data);
            } else {
                setloader(false);
                //console.log(response);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: response?.response_data?.message,
                    isfalse: true,
                }));
            }
        } catch (error) {
            setloader(false);
            //console.log(error)
        }
    };
    // onchange function for pagination
    function onChangeTable(pagination) {
        // ""
        //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        // setClientDataList(dataTableInitialLoader(TableColumn));
        //console.log("----->", data.slice((current - 1) * pageSize, current * pageSize))
        setClientDataList([]);
        setTimeout(() => {
            setClientDataList(
                data.slice((current - 1) * pageSize, current * pageSize)
            );

            setpageSize(pageSize)
            setcurrentPage(current);
            setTableLoader(false);
        }, 2000);
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (visible?.type == "Edit_Client_Name") {
            setClientData((pre) => ({ ...pre, name: value }));
        } else {
            setClientData((pre) => ({ name: value }));
        }
    };


    const handleSearch = async () => {
        // ""
        if (searchText.length > 0) {
            setloader(true)

            setData([]);
            setClientDataList([]);
            const response = await ManageApis("post", global.clientService + `?searchText=${searchText}`)
            if (response.message == "Success") {
                setloader(false);
                setData(response?.response_data);
                setClientDataList(response?.response_data);
            }
            else {
                setloader(false);
                //console.log(response);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: response?.response_data?.message,
                    isfalse: true,
                }));
            }
        }
        else {
            setData([]);
            setClientDataList([]);
            getClientsListData()
        }
    }
    const clearSearch = () => {
        setSearchText('');
        getClientsListData();
    }


    const handlesearchTextChange = (value) => {
        setSearchText(value)
        // try {
        //     ""
        //     if (formatingValue(value, 20, /[^a-zA-Z\s]/g)) {
        //         setClientData([])
        //         const filterDate = clientData.filter((itm) => (itm?.name?.toLowerCase().includes(value?.toLowerCase())))
        //         //console.log(filterDate)
        //         setClientDataList(filterDate)
        //     } else {
        //         setClientData([])
        //         setClientDataList(data)
        //     }

        // } catch (error) {
        //     // console.error("An error occurred:", error.message);
        // }
    }

    useEffect(() => {
        //console.log("=-------------------->", clientDataList)
    }, [clientDataList])


    return (
        <>
            {loader && <Loader />}
            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                handlecancel={() => setShowAlert(AlertinitialValue)}
            />

            <div className="px-3 ">
            {user_Roll !== "AdminClient" ?
                <MenuHeader
                    handleChange={() =>
                        setvisible((pre) => ({
                            ...pre,
                            show: true,
                            type: "New_Account",
                        }))
                    }
                    btnLabel={"Add Account"}
                    headerName={true}
                    searchText={searchText}
                    clearSearch={clearSearch}
                    handlesearchTextChange={handlesearchTextChange}
                    handleSearch={handleSearch}
                />
            :
                <MenuHeader
                    headerName={true}
                    searchText={searchText}
                    clearSearch={clearSearch}
                    handlesearchTextChange={handlesearchTextChange}
                    handleSearch={handleSearch}
                />
            }

                {/* data table component for list data */}
                <div className="overflow-auto accountDashBoard scrollbar1">

                    <DataTable
                        columnData={TableColumn}
                        rowData={clientDataList}
                        loading={tableLoader}
                        current={currentPage}
                        total={data.length}
                        pageSize={pageSize}
                        onChangeTable={onChangeTable}
                    />
                </div>
            </div>

            {/* popup modal component with children passing */}
            <PopupModal
                title={visible?.type?.replaceAll("_", " ")}
                size="md"
                visible={visible.show}
                handleClose={() => {
                    setvisible((pre) => ({ show: false, type: "" }));
                    setClientData({});
                }}
            >
                <div>
                    <InputComponent2
                        label={"Account Name"}
                        onchange={handleChange}
                        value={clientData?.name}
                        maxLength={45}
                    />
                    <div>
                        <button
                            className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100"
                            disabled={Object.keys(clientData).length == 0 || !clientData.name}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </PopupModal>
        </>
    );
}

export default Client;
